import React from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import DownloadIcon from '@mui/icons-material/Download';
import { useTranslation } from 'react-i18next';
import { exportLogs } from '../../../utils/scoringLog';

export default function StageSelect() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { stages } = useOutletContext();

  return (
    <Box sx={{ py: 4 }}>
      <Typography variant="h6" gutterBottom sx={{ textAlign: 'center' }}>{t('scoring.stage')}</Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, maxWidth: 400, mx: 'auto' }}>
        {stages.map((stage, idx) => (
          <Button
            key={idx}
            variant="contained"
            color="primary"
            fullWidth
            disabled={stage.inactive}
            onClick={() => navigate(`stage/${idx + 1}`)}
            sx={{ py: 1.5, textTransform: 'none', justifyContent: 'flex-start' }}
          >
            <Box sx={{ textAlign: 'left' }}>
              <Typography variant="body1">
                {t('results.stageN', { n: idx + 1 })}{stage.title ? `: ${stage.title}` : ''}
              </Typography>
              {stage.inactive && (
                <Typography variant="caption" color="error.light">{t('stages.inactive')}</Typography>
              )}
            </Box>
          </Button>
        ))}
      </Box>
      <Box sx={{ textAlign: 'center', mt: 3 }}>
        <Button size="small" startIcon={<DownloadIcon />} onClick={() => exportLogs()} sx={{ textTransform: 'none', color: 'text.secondary' }}>
          {t('scoring.exportLog', 'Export Scoring Log')}
        </Button>
      </Box>
    </Box>
  );
}
